<template>
  <validation-observer ref="validacao">
    <cadastro-base
      :salvar="salvar"
      :cancelar="cancelar"
      :is-editar="modoEdicao"
      :validacao="validacao"
      :is-empresa="true"
      @exibirErros="exibirErros(validacao)"
    >
      <template slot="conteudo">
        <b-form-checkbox
          v-model="form.ativa"
          name="check-button"
          style="float:right;"
          switch
        >
          <span style="font-size: 14px">Empresa ativa</span>
        </b-form-checkbox>

        <b-form-checkbox
          v-model="form.favorita"
          name="check-button"
          style="float:right;"
          class="mr-5"
          switch
        >
          <span style="font-size: 14px">Empresa favorita</span>
        </b-form-checkbox>

        <b-tabs content-class="mt-3">
          <b-tab
            title="Grupo geral"
            no-body
            active
          >
            <secao-geral
              v-model="form"
              @buscar-empresa="form = $event"
              @erroManual="erroManual"
            />
            <secao-contador v-model="form.contador" />
            <secao-cnae v-model="form" />
            <b-row>
              <b-col cols="12">
                <divisoria-descricao
                  class="mt-2"
                  :titulo="'Endereço'"
                  :descricao="'Adicione as informações sobre o endereço e contato desta empresa'"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <endereco v-model="form.endereco" />
              </b-col>
            </b-row>
          </b-tab>
          <b-tab
            no-body
            title="Sócios"
          >
            <secao-socio v-model="form" />
          </b-tab>
          <b-tab
            no-body
            title="Conf. rotinas e-CAC"
          >
            <secao-conf-ecac v-model="form" />
          </b-tab>
          <b-tab
            no-body
            title="Senhas de acesso"
          >
            <senhas-acesso v-model="form" />
          </b-tab>
        </b-tabs>
      </template>
    </cadastro-base>
  </validation-observer>
</template>

<script>

import {
  defineComponent, ref,
} from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { useRouter } from '@core/utils/utils'
import {
  required,
} from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import useAbility from '@/libs/acl/ability'
// eslint-disable-next-line import/no-cycle
import useEmpresa from './useEmpresa'

export default defineComponent({
  name: 'EmpresaCadastro',
  components: {
    ValidationProvider,
    ValidationObserver,
    SecaoGeral: () => import('../secao-geral/SecaoGeral.vue'),
    SecaoCnae: () => import('../secao-cnae/SecaoCnae.vue'),
    SecaoSocio: () => import('../secao-socios/SecaoSocios.vue'),
    SecaoConfEcac: () => import('../configuracoes-ecac/SecaoConfEcac.vue'),
    SecaoContador: () => import('../secao-contador/SecaoContador.vue'),
    SenhasAcesso: () => import('../senhas-acesso/SenhasAcesso.vue'),
    CadastroBase: () => import('@pilar/components/cadastro-base/CadastroBase.vue'),
    Endereco: () => import('@pilar/components/endereco/Endereco.vue'),
    DivisoriaDescricao: () => import('@pilar/components/divisoria-descricao/DivisoriaDescricao.vue'),
  },
  data() {
    return {
      camposMapeados: {
        'Razao social': 'Grupo Geral',
        Contador: 'Grupo Geral',
        'Email de contato': 'Grupo Geral',
        CEP: 'Grupo Geral',
        contador: 'Grupo Geral',
        Cnae: 'Grupo Geral',
        CnaeSec: 'Grupo Geral',
        Cidade: 'Grupo Geral',
        cadInscricao: 'Grupo Geral',
        UF: 'Grupo Geral',
      },
    }
  },
  setup() {
    const { route } = useRouter()
    const modoEdicao = route.value.path.indexOf('editar') > 0
    const validacao = ref(null)

    const {
      salvar,
      carregar,
      novo,
      cancelar,
      form,
    } = useEmpresa(modoEdicao, validacao, useAbility)
    if (modoEdicao) {
      carregar(route.value.params.id)
    } else {
      novo()
    }

    return {
      modoEdicao,
      required,
      salvar,
      carregar,
      novo,
      cancelar,
      form,
      validacao,
    }
  },
  methods: {
    erroManual(validacao) {
      setTimeout(() => {
        const getErro = validacao
        this.$refs.validacao = getErro
      })
    },
    exibirErros(validacao) {
      setTimeout(() => {
        const camposComErro = new Set()
        const getValidacao = validacao
        const getErro = getValidacao.errors
        const erros = Object.keys(getErro)
        erros.forEach(erro => {
          if (getErro[erro].length > 0) {
            camposComErro.add(erro)
          }
        })
        const campos = this.identificarCampos(camposComErro)
        if (campos.length > 0) {
          const mensagem = `Erro ao gravar. Verifique os campos na aba ${campos.join(', ')}`
          this.$erro(mensagem, 'danger')
        } else {
          this.$erro('Erro ao gravar.', 'danger')
        }
      }, 50)
    },
    identificarCampos(camposComErro) {
      const secoes = new Set()
      camposComErro.forEach(campo => {
        if (this.camposMapeados[campo]) {
          secoes.add(this.camposMapeados[campo])
        } else {
          const prefixo = campo.split('.')[0].split('[')[0]
          Object.keys(this.camposMapeados).forEach(key => {
            if (key.startsWith(prefixo) || campo.startsWith(key.split('.')[0])) {
              secoes.add(this.camposMapeados[key])
            }
          })
        }
      })
      return Array.from(secoes)
    },
  },
})
</script>
